"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@/utilities/core/cn";
import { BracketGrid } from "./BracketGrid";
import type { BracketData } from "./types";
export interface BracketProps {
  data: BracketData;
  emptyMessage?: string;
  className?: string;
}
export function Bracket(t0) {
  const $ = _c(12);
  const {
    data,
    emptyMessage,
    className
  } = t0;
  if (data.rounds.length === 0) {
    let t1;
    if ($[0] !== className) {
      t1 = cn("flex flex-col items-center justify-center py-16 text-center", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = emptyMessage || "No bracket data available.";
    let t3;
    if ($[2] !== t2) {
      t3 = <p className="text-muted-foreground text-sm">{t2}</p>;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
      t4 = <div className={t1}>{t3}</div>;
      $[4] = t1;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t1;
  if ($[7] !== data) {
    t1 = <BracketGrid data={data} />;
    $[7] = data;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== className || $[10] !== t1) {
    t2 = <div className={className}>{t1}</div>;
    $[9] = className;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}